import React, { useState, useEffect, useCallback } from "react";
import "./LoginRegister.css";
import { Input, message, Modal } from "antd";
import { bindPhone } from "../api/user";

const LoginRegister: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [urlParams, setUrlParams] = useState<Record<string, string>>({});
  const [successVisible, setSuccessVisible] = useState(false);
  const [messageTitle, setMessageTitle] = useState("验证成功，完成绑定！");
  const [responseCode, setResponseCode] = useState<number | null>(null);
  // 进入的时候获取URL参数（如果需要传 inviteCode）
  useEffect(() => {
    const reviceParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};
    reviceParams.forEach((value, key) => {
      params[key] = value;
    });
    setUrlParams(params);
  }, []);

  // 绑定手机号（新）
  const handleBind = () => {
    if (!phone || phone.length !== 11) {
      message.error("请输入正确的手机号码");
      return;
    }
    setLoading(true);
    // 这里假设 bindkey 从 URL 参数中取，如果没有就默认空字符串
    const bindkey = urlParams.bindkey || "";
    console.log("bindkey:", bindkey);
    console.log("phone:", phone);
    
    bindPhone(bindkey, phone)
      .then((res) => {
        setResponseCode(res?.code ?? null);
        if (res?.code === 200) {
          console.log("绑定成功:", res);
          setMessageTitle(res?.data ?? "验证成功，完成绑定！");
          setSuccessVisible(true); // 显示成功弹窗
        } else {
          setMessageTitle(res?.data ?? "绑定失败！");
          setSuccessVisible(true); // 显示成功弹窗
        }
      })
      .catch((error) => {
        setMessageTitle("网络错误，请重试！");
        setSuccessVisible(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className="login-register-container"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="phone-only" style={{ paddingLeft: 40, paddingRight: 40 }}>
        <div className="input-group">
          <div
            className="input-hint"
            style={{
              paddingTop: 20,
              color: "#000",
              marginBottom: 30,
              fontSize: 16,
              textAlign: "center",
            }}
          >
            请输入您在门店注册会员的手机号码
          </div>
          <Input
            type="tel"
            placeholder="请输入手机号码"
            value={phone}
            onChange={(e) => {
    const value = e.target.value;
    // 只允许输入数字
    if (/^\d*$/.test(value)) {
      setPhone(value);
    }
  }}
            maxLength={11}
            disabled={loading}
          />
        </div>

        <button
          className="submitBtn"
          onClick={handleBind}
          disabled={loading}
          style={{ width: "80%", margin: "0 auto", display: "block" }}
        >
          {loading ? "提交中..." : "验证绑定"}
        </button>
      </div>

      {/* 绑定成功弹窗 */}
      <Modal
        title={<div style={{ textAlign: "center" }}>{messageTitle}</div>}
        open={successVisible}
        footer={null}
        closable={false}
        centered
        width={300}
      >
        <div style={{ textAlign: "center", marginTop: 30 }}>
          <button
            className="submitBtn"
            onClick={() => {
              if (responseCode === 200) {
                console.log("关闭窗口");
                // 微信环境下使用 WeixinJSBridge 关闭页面
                if (typeof (window as any).WeixinJSBridge !== 'undefined') {
                  (window as any).WeixinJSBridge.call('closeWindow');
                } else {
                  // 非微信环境或 WeixinJSBridge 未就绪
                  document.addEventListener('WeixinJSBridgeReady', () => {
                    (window as any).WeixinJSBridge.call('closeWindow');
                  }, false);
                  
                  // 如果不是微信环境，尝试其他方式
                  setTimeout(() => {
                    if (window.history.length > 1) {
                      window.history.back();
                    } else {
                      // 提示用户手动关闭
                      message.info('请手动关闭此页面');
                    }
                  }, 300);
                }
                setSuccessVisible(false);
              } else {
                setSuccessVisible(false);
              }
            }}
            style={{ width: 110, height: 40 }}
          >
            我知道了
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default LoginRegister;
